import { SUPABASE_URL } from "@/integrations/supabase/client";
import { apiFetch } from "@/lib/api-fetch";

/** The draft cancelled since the current approval of a vaga still in Aprovado (the kanban card). */
export interface RascunhoCancelado {
  vaga_id: string;
  projeto_id: string;
  freelancer_id: string | null;
  freelancer_nome: string | null;
  cancelado_em: string;
}

const PROJETOS_URL = `${SUPABASE_URL}v3/projetos`;

export const projetoRascunhoApi = {
  cancel: (projetoId: string) =>
    apiFetch<{ projeto_id: string; vaga_id: string | null }>(`${PROJETOS_URL}/${projetoId}/cancelar`, { method: "POST" }),

  restore: (projetoId: string) =>
    apiFetch<{ projeto_id: string; vaga_id: string | null }>(`${PROJETOS_URL}/${projetoId}/voltar-para-rascunho`, {
      method: "POST",
    }),

  cancelledByVaga: (vagaIds: string[]) =>
    apiFetch<{ itens: RascunhoCancelado[] }>(
      `${PROJETOS_URL}/rascunhos-cancelados?vaga_ids=${encodeURIComponent(vagaIds.join(","))}`,
    ),
};
